import { Button } from '@progress/kendo-react-buttons';
import { classNames } from '@progress/kendo-react-common';
import { CurrencyValue } from 'components';
import { AdjustmentType } from 'enums';
import styles from './AdjustmentCategory.module.scss';

export type AdjustmentCategoryProps = {
    type: AdjustmentType,
    title: string,
    amount: number,
    isSelected: boolean,
    selectCategory: (category: AdjustmentType) => void,
    className: string,
}

export const AdjustmentCategory = ({ type, title, amount, isSelected, selectCategory, className }: AdjustmentCategoryProps) => {
    const selectedClassName =  classNames(className, styles.button, { [styles.selected]: isSelected });
    const handleOnClick = () => selectCategory(type);

    return  (
            <div onClick={handleOnClick} className={classNames(selectedClassName)}>
                <span className={styles.type}>{title}</span>
                <CurrencyValue className={styles.value} value={amount} />
            </div>
            )
    };